import React from "react";
import { useSelector } from "react-redux";

import Footer from "../../components/Footer";
import SectionHeader from "../../components/SectionHeader";
import baseLogo from "../../images/logo.png";

const DeveloperFirst = () => {
  const session = useSelector(state => state.auth.session);
  const logo = session?.options?.logo ?? baseLogo;

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <SectionHeader logo={logo} />
      <main className="flex flex-col space-y-8 p-4 md:p-8">
        <div className="mb-8 space-y-4 md:space-y-0 md:space-x-4 lg:p-8">
          <h5 className="my-4 text-center text-3xl font-medium md:text-3xl">
            Developer First
          </h5>
          <p className="mt-8 text-base text-gray-600 md:text-lg">
            To be to eCommerce, what Stripe is to online payments
            <br />
            <br />
            Commerce is movement of goods from point A to B. But between A and
            B, it can take various forms of varying complexity. Own inventory vs
            marketplace, centralized vs decentralized, movement of payment is
            bottom-up vs. top-down, Prices controlled vs. free market pricing
            etc.{" "}
            <span className="text-red-400">
              Now startups and businesses of all sizes don’t have to spend
              months of development effort in developing their ecommerce system.
              Using Namaste, they can link their databases to Namaste, and
              within couple of hours can create their ecommerce system of any
              sophistication that their business model demands.
            </span>{" "}
            Frontend is fully customizable if they need to customize the user
            experience.
          </p>
        </div>

        <section className="mb-8 flex flex-col items-center space-y-4 md:flex-row md:items-start md:space-y-0 md:space-x-4 lg:p-8">
          <div className="flex flex-col space-y-4 p-4 md:order-2 md:w-1/2">
            <h1 className="text-3xl font-medium md:text-4xl">
              Access Type and Order Flow
            </h1>
            <p className="text-base text-gray-600 md:text-lg">
              Who sees whose product in your ecommerce system, Whose order will
              go where. From which warehouse should a particular user’s order be
              fulfilled? Is it hierarchical, geographical or a pre-defined
              mapping? Using Namaste you can take care of all the cases. While
              we have only created a UI for a case one of users asked for, in
              the backend it’s completely customizable.
            </p>
          </div>
          <div className="relative flex w-full flex-col items-center md:order-1 md:w-1/2">
            <div className="relative w-full">
              <iframe
                className="absolute top-0 left-0 h-full max-h-full w-full p-2" // Add padding here
                src="https://www.youtube.com/embed/IlIaIHQpl2M"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video Title"
              />
            </div>
          </div>
        </section>

        <section className="mb-8 flex flex-col items-center space-y-4 md:flex-row md:items-start md:space-y-0 md:space-x-4 lg:p-8">
          <div className="flex flex-col space-y-4 p-4 md:order-1 md:w-1/2">
            <h1 className="text-3xl font-medium md:text-4xl">
              Custom Keywords and Aggregation
            </h1>
            <p className="text-base text-gray-600 md:text-lg">
              Create any number of custom keywords, add values to it and
              aggregate the products according to it (for e.g keyword can be
              “Color” and values can be “red” “blue” and “green” and you can
              aggregate the products by color in your homepage). Filters across
              the app will update with the keywords you add. You can add custom
              icons to these keywords and you can merge keywords together too.
              With this, you can make discovery of products fully tailored to
              your business. Some businesses have thousands of SKUs while some
              others have only a handful. Smart use of keywords can reduce
              product discovery problems much lesser.
            </p>
          </div>
          <div className="relative flex w-full flex-col items-center md:order-2 md:w-1/2">
            <div className="relative w-full">
              <iframe
                className="absolute top-0 left-0 h-full max-h-full w-full p-2"
                src="https://www.youtube.com/embed/z2cI5_99vTA"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video Title"
              />
            </div>
          </div>
        </section>

        <section className="mb-8 flex flex-col items-center space-y-4 md:flex-row md:items-start md:space-y-0 md:space-x-4 lg:p-8">
          <div className="flex flex-col space-y-4 p-4 md:order-2 md:w-1/2">
            <h1 className="text-3xl font-medium md:text-4xl">Layout Engine</h1>
            <p className="text-base text-gray-600 md:text-lg">
              With layout engine you can customize all the layouts in your app
              real-time with very minimal development overhead. We developed
              this feature for internal use when we were an eCommerce business.
              It was a giant waste of time to make developers change layouts.
              With the layout engine, even our non-tech business staff could
              update the layouts according to their needs.
            </p>
          </div>
          <div className="relative flex w-full flex-col items-center md:order-1 md:w-1/2">
            <div className="relative w-full">
              <iframe
                className="absolute top-0 left-0 h-full max-h-full w-full p-2"
                src="https://www.youtube.com/embed/IlIaIHQpl2M"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video Title"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default DeveloperFirst;
